module.exports = __webpack_public_path__ + "static/img/FMDP4.546f7c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/schoolEnrollment/FMDP4.png
// module id = dEX1
// module chunks = 1